import styled, { css } from 'styled-components'

export const Container = styled.div`
  padding: 10px 10px 0 10px;
  flex: 1;
`

export const InputField = styled.textarea`
  ${({ theme }) => css`
    font-size: 16px;
    border-width: 1px;
    border-radius: 8px;
    height: 140px;
    padding: 10px;
    margin-top: 10px

    background-color: ${theme.colors.inputTextBackground};
    color: ${theme.colors.text};
    border-color: ${theme.colors.text};
  `}
`

export const TaskInformationLabel = styled.span`
  ${({ theme }) => css`
    font-size: 16px;
    padding-bottom: 5px;
    color: ${theme.colors.text};
  `}
`

export const InputInformationText = styled.span`
  ${({ theme }) => css`
    font-size: 16px;
    color: ${theme.colors.text};
    padding-bottom: 16px;
  `}
`

export const InputContainer = styled.div`
  padding-top: 20px;
`
